module.exports = __webpack_public_path__ + "static/media/loc1_img28.678b39ab.jpg";